import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/logos/ottilianer.svg")